import { render } from "./styleguide.vue?vue&type=template&id=4f7b0680"
import script from "./styleguide.vue?vue&type=script&lang=js"
export * from "./styleguide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__